<template>
  <v-layout class="d-flex flex-column align-center">
    <router-view name="header" />
    <v-main class="main d-flex flex-column">
      <router-view />
    </v-main>
    <router-view name="footer" />
  </v-layout>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'MainLayout',

  data() {
    return {
      //
    }
  },
})
</script>

<style scoped>

.main {
  width: 100vw;
}

</style>